const LoadingTimeline = () => {
  return (
    <dl className="animate-pulse w-full">
      {[1, 2, 3, 4, 5].map((num: number) => (
        <div key={num} className="relative pb-5 w-full">
          <span
            className="absolute top-4 left-1.5 -ml-px h-full w-0.5 bg-gray-200"
            aria-hidden="true"
          />
          <div className="min-w-0 flex space-x-4 w-full">
            <dt className="text-sm text-gray-500">
              <span
                className={
                  "h-3 w-3 bg-tertiaryColor-light rounded-full flex items-center justify-center"
                }
              ></span>
            </dt>
            <dd className="flex flex-col gap-2 w-full">
              <p className="h-2 w-full bg-neutralColor-light rounded-full"></p>
              <span className="h-1 w-24 bg-neutralColor-light rounded-full"></span>
            </dd>
          </div>
        </div>
      ))}
    </dl>
  );
};

export default LoadingTimeline;
